module.exports = __webpack_public_path__ + "assets/img/202111-3W.7f491d7e.png";